import { createContext, useContext, useEffect, useState } from "react";
import { LOCAL_STORAGE_USER_UPDATE_EVENT } from "../auth/checkAuth";

export interface IModuleAccessInfo {
  id: number;
  count1: number;
  count2: number;
}

export interface IModuleAccessInfoList {
  idCountCountList: Array<IModuleAccessInfo>;
}
export interface IUser {
  activationDate?: any;
  changeDate: number;
  balance: number;
  balanceSms: number;
  freeBalance: number;
  balanceReputation: number;
  questionPrice: number;
  income: number;
  customerTypeId?: any;
  levels?: any;
  deanType: number;
  disabled: boolean;
  examTakingId?: any;
  features: string;
  grade: number;
  id: number;
  inExam?: any;
  loginResultType: string;
  majorId?: any;
  name: string;
  profileImageId: number;
  registrationStateId: number;
  schools: string;
  serverTime: number;
  sex: boolean;
  tempId?: any;
  userName: string;
  userTypeId: number;
  studentsFollowerCount: number;
  nonStudentsFollowerCount: number;
  followingCount: number;
  loginHistoryId: number;
  isSurveyForced: boolean;
  lastActivityDatetime?: any;
  isDemo: boolean;
  isAuthor?: any;
  changePassRequired: boolean;
  changeUserNameRequired: boolean;
  surveyID?: any;
  surveyDescription?: any;
  surveyTitle?: any;
  currentStreak: number;
  maxStreak: number;
  startEducationalYearDate: number;
  fireBaseToken?: any;
  cityId?: any;
  cityName?: any;
  sideMenu: string;
  mainMenu: string;
  charge: number;
  spent: number;
  blocked: boolean;
  montaAcademyLinkAccess: boolean;
  calendarLinkAccess: boolean;
  isExamSingleQuestion: boolean;
  linkChangeDate: string;
  titleTransient?: any;
  accessTypeId: number;
  isRelated: boolean;
  schoolProfileImageID: number;
  typeId?: number;
  hasAccessToBuyEducationPack?: boolean;
  moduleAccessInfo: null | string | IModuleAccessInfoList;
}

const context = createContext<IUser | null>(null);

export const UserProvider = ({ children }: any) => {
  const [user, setUser] = useState<IUser | null>(null);
  const setUserCallback = () => {
    const localStorageUser = localStorage.getItem("user");
    localStorageUser && setUser(JSON.parse(localStorageUser || ""));
  };
  useEffect(() => {
    window.addEventListener(LOCAL_STORAGE_USER_UPDATE_EVENT, setUserCallback);
    setUserCallback();
    return () => {
      window.removeEventListener(
        LOCAL_STORAGE_USER_UPDATE_EVENT,
        setUserCallback
      );
    };
  }, []);
  return <context.Provider value={user as IUser}>{children}</context.Provider>;
};

export const useUser = () => {
  return useContext(context);
};
